// extracted by mini-css-extract-plugin
module.exports = {"suggestionBox":"styles_suggestionBox__25gew"};